const VIRIDIS_STOPS = [
    '#440154',
    '#48186a',
    '#472d7b',
    '#424086',
    '#3b528b',
    '#33638d',
    '#2c728e',
    '#26828e',
    '#21918c',
    '#1fa088',
    '#28ae80',
    '#3fbc73',
    '#5ec962',
    '#84d44b',
    '#addc30',
    '#d8e219',
    '#fde725',
];

function colorChannels(color: string): number[] {
    return [
        Number.parseInt(color.slice(1, 3), 16),
        Number.parseInt(color.slice(3, 5), 16),
        Number.parseInt(color.slice(5, 7), 16),
    ];
}

function channelHex(channel: number): string {
    return Math.round(channel).toString(16).padStart(2, '0');
}

export function viridisShade(value: number): string {
    const shadePosition = Math.max(0, Math.min(value, 1)) * (VIRIDIS_STOPS.length - 1);
    const lowerStopIndex = Math.floor(shadePosition);
    const upperStopIndex = Math.ceil(shadePosition);

    if (lowerStopIndex === upperStopIndex) {
        return VIRIDIS_STOPS[lowerStopIndex];
    }

    const lowerChannels = colorChannels(VIRIDIS_STOPS[lowerStopIndex]);
    const upperChannels = colorChannels(VIRIDIS_STOPS[upperStopIndex]);
    const fraction = shadePosition - lowerStopIndex;
    const channels = lowerChannels.map((lowerChannel, index) =>
        lowerChannel + (upperChannels[index] - lowerChannel) * fraction
    );

    return `#${channels.map(channelHex).join('')}`;
}
